import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Button, Card, CardBody, CardHeader, Flex, Text} from "@chakra-ui/react";
import React, {useEffect, useRef, useState} from "react";
import {defaultBoat} from "../../../utils/boat-utils";
import {useCustomToast} from "../../../components/CustomToast/CustomToast";
import {boatService} from "../../../services/boatService";
import {ROUTES} from "../../../constants/routes-path";
import {DrawIoEmbed} from "react-drawio";

function BoatDrawing() {

    const {id} = useParams();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const showToast = useCustomToast();

    const [boat, setBoat] = useState(defaultBoat)

    const [imgData, setImgData] = useState(null);
    const drawioRef = useRef(null);

    useEffect(() => {
        if (id) {
            fetchBoat(id);
        }
    }, [id]);

    const fetchBoat = async (id) => {
        try {
            const boatResponse = await boatService.find(id);
            setBoat(boatResponse);
        } catch (err) {
            showToast({title: t(err), status: "error"});
        }
    };

    useEffect(() => {
        if (imgData) {
            const newBoatData = {...boat.data, desenho: {image: imgData} };

            boatService.update(id, {
                status: 'FINALIZADO',
                data: newBoatData,
            })
                .then(() => navigate(ROUTES.boatsDetailsPath.replace(":id", id)))
                .catch((err) => showToast({title: t(err), status: "error"}));
        }
    }, [imgData]);

    const doExport = () => {
        if (drawioRef.current) {
            drawioRef.current.exportDiagram({
                format: 'png'
            });
        }
    };

    const onCancel = () => {
        navigate(ROUTES.boatsPath);
    }

    const onSubmit = () => {
        doExport();
    }

    return (
        <>
            <Flex direction="column" pt={{sm: "125px", lg: "75px"}} h="100vh" w="100%">
                <Card px="0px" pt="10px" mb="24px" flex="1" display="flex" flexDirection="column" minH="0">
                    <CardHeader px="22px">
                        <Text fontWeight="bold">{t('boat.new.drawing')}</Text>
                    </CardHeader>
                    <CardBody display="flex" flexDirection="column" flex="1" minH="0">
                        <Flex direction="column" flex="1" minH="0" gap="20px">
                            <DrawIoEmbed
                                ref={drawioRef}
                                style={{ flex: 1, minHeight: 0 }}
                                urlParameters={{
                                    spin: false,
                                    libraries: false,
                                    saveAndExit: false,
                                }}
                                configuration={{
                                    defaultLibraries: "",
                                    appendCustomLibraries: true,
                                    defaultCustomLibraries: ["Uhttps%3A%2F%2Fa2f-files.s3.amazonaws.com%2Fboat-accident-assets.xml"],
                                }}
                                onExport={(data) => setImgData(data.data)}
                            />

                            <Flex w="100%" justify="space-between">
                                <Button
                                    variant="light"
                                    fontSize="sm"
                                    w="125px"
                                    onClick={onCancel}
                                >
                                    {t("system.actions.cancel")}
                                </Button>
                                <Button
                                    w="125px"
                                    variant="dark"
                                    fontSize="sm"
                                    onClick={onSubmit}
                                >
                                    {t('system.actions.save')}
                                </Button>
                            </Flex>
                        </Flex>
                    </CardBody>
                </Card>
            </Flex>
        </>
    );
}

export default BoatDrawing;